import { shutdown as shutdownIntercom } from '@intercom/messenger-js-sdk'
import { useCallback } from 'react'
import { auth } from '../lib/auth'

export function useSignOut() {
  return useCallback(async () => {
    // Clear the Intercom session so the next user doesn't inherit this one.
    shutdownIntercom()
    await auth.signOut()
    window.location.href = '/app'
  }, [])
}
